// 促销-产品详情页优惠信息
import ajax from '@/utils/ajax';

const header = '/web';
export const reqproductDetailDiscount = (param) => ajax(`${header}/v1/product-detail/discount`, param);

export const reqPaySuccess = (orderNo) => ajax(`${header}/v1/pay/success/info?orderNo=${orderNo}`);
